interface PaletteColor {
  light?: string;
  main: string;
  dark?: string;
  contrastText?: string;
}

// Green - Blue
export const primary: PaletteColor = {
  main: '#132968',
  dark: '#0d1c48',
  light: '#5E90CC',
  contrastText: '#FFF',
};

export const secondary: PaletteColor = {
  main: '#FA6B6B',
  dark: '#af4a4a',
  light: '#fb8888',
  contrastText: '#FFF',
};

export const success: PaletteColor = {
  main: '#2e7d32',
};

export const error: PaletteColor = {
  main: '#c62828',
};

export const warning: PaletteColor = {
  main: '#f9a825',
};
